// 存储token
let token = ''
// 存储没有Breare字段的token
let readToken = ''
// 获取token
export const getToken = (): string => token
// 获取没有Breare字段的token
export const getReadToken = (): string => readToken
// 设置token
export const setToken = (value: string): void => {
  token = value
}
// 设置没有Breare字段的token
export const setReadToekn = (value: string): void => {
  readToken = value
}

export const getLang = () => {
  const lang = window.localStorage.getItem('lang')
  if (lang === 'tc') {
    return 'tc'
  }
  if (lang === 'sc') {
    return 'sc'
  }
  if (lang === 'en') {
    return 'en'
  }
}
export const getOldLang = () => {
  const lang = window.localStorage.getItem('lang')
  if (lang === 'tc') {
    return 'zh-TW'
  }
  if (lang === 'sc') {
    return 'zh-CN'
  }
  if (lang === 'en') {
    return 'en-US'
  }
}
